import de from '@/i18n/de.json'

export type SupportedLanguages = {
  [key: string]: object
}

export const supportedLanguages: SupportedLanguages = Object.freeze({
  'de-DE': de
})
